import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 0A3.5 3.5 0 0 0 0 3.5v7A3.5 3.5 0 0 0 3.5 14h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 10.5 0zm7.04 4.315a.625.625 0 1 0-1.08-.63L6.324 9.06 4.39 7.512a.625.625 0 0 0-.78.976l2.047 1.638a1.1 1.1 0 0 0 .912.228 1.13 1.13 0 0 0 .761-.54z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceValidationCheckboxSquare = { render };
export {
  interfaceValidationCheckboxSquare as default,
  render
};
//# sourceMappingURL=interface-validation-checkbox-square.svg.js.map
